export const tripTypeCols = [
  { headerName: 'Trip Type', field: 'serviceType', width: 180 },
  { headerName: 'Vehicle Type', field: 'vehicleType', width: 100 },
  { headerName: 'SR Flag Fall', field: 'srFlagFall', width: 100 },
  { headerName: 'SR Share %', field: 'srSharePercentOnCost', width: 100 },
  { headerName: 'Flag Fall', field: 'flagFall', width: 100 },
  { headerName: 'Price/KM', field: 'costPerKM', width: 110 },
  { headerName: 'Price/Min', field: 'costPerMin', width: 120 },
];
